import { Session, Peer } from '../../core';
import { VideoRoomPluginHandler } from '../../plugins/VideoRoomPlugin';
import { VideoRoomParticipant } from './participant';

export class VideoRoomPublisher extends VideoRoomParticipant {
    private peer: Peer | undefined;

    static async create(session: Session, opaqueId: string) {
        const pluginHandler = await VideoRoomPluginHandler.create(
            session,
            opaqueId
        );
        return new VideoRoomPublisher(pluginHandler);
    }

    async connect(config: RTCConfiguration = {}) {
        this.peer = new Peer(config);

        this.peer.addCandidateListener(async candidate => {
            await this.pluginHandler.trickle({
                candidate: candidate.candidate,
                sdpMid: candidate.sdpMid,
                sdpMLineIndex: candidate.sdpMLineIndex,
            });
        });
    }

    async publish(
        localStream: MediaStream,
        settings = { audio: true, video: true }
    ) {
        const peer = this.peer;
        if (!peer) throw new Error('publish must be invoked after connect');

        const localSdp = await peer.createOffer(localStream);

        //this.pluginHandler.publish({ videocodec: 'vp9' }, localSdp)
        const { jsep } = await this.pluginHandler.configure(settings, localSdp);
        // offer送信成功
        if (jsep) {
            this.peer?.acceptAnswer(jsep);
        }
    }
}
